import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Input from "antd/es/input/Input";
import * as Yup from "yup";
import { Field, Form, Formik, useFormik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";

import config from "../../../../config/config";
import { PlusIcon } from "../../../../common/imagePath";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  AWS_IMAGE_FOLDER,
  AWS_IMAGE_FOLDER_CATEGORIES,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { uploadAWS } from "../../../../common/AWSHelper";
import Select from "react-select";
import DataTable from "react-data-table-component";
// import * as Yup from 'yup';
// import { getUserPermission } from "../../../../common/UserPermission";
import { checkUserPermission } from "../../../../common/UserPermission";
import { Noimage } from "../../../../common/imagePath";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "manage-categories";
let PERMISSION_EDIT = "edit-categories";
let PERMISSION_DELETE = "delete-categories";

// let userPermission = getUserPermission();

const Categories = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  // const [userPermission, setUserPermission] = useState([]);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [valueAllChecked, setValueAllChecked] = useState();
  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    Hidefromgrid: false,
    ParentID: 0,
    Color: "",
    Imagename: "",
    CategoryInfopopup: "",
  });

  //   {
  //     "ID": 4,
  //     "Name": "Batteries & Mods",
  //     "Hidefromgrid": false,
  //     "ParentID": 577,
  //     "Color": "",
  //     "Imagename": "https://sonar-production-bucket.s3.amazonaws.com/CATEGORIES/42024_1712670158752.jpg",
  //     "CategoryInfopopup": null
  // }

  console.log(formValues, "formValues");
  const [selectedParentCategory, setselectedParentCategory] = useState(0);
  console.log(selectedParentCategory, "selectedParentCategory salman");
  const [Imagename, setImagename] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [ImageUrl, setImageUrl] = useState("");
  const [CategoryInfopopup, setCategoryInfopopup] = useState("");
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });
  const [data, setData] = useState([]);
  const [filterdata, setfilterdata] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(100);
  const [sortingId, setSortingId] = useState(4);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedData, setSelectedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchtext, setSearchText] = useState("");
  const [checkedBox, setCheckedBox] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [parentrefquickbookid, setParentRefQuickBookId] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  console.log(previewImage, "previewImage123");
  const [showLoaderUploadImage, setShowLoaderUploadImage] = useState(false);


  // console.log(selectedParentCategory,"electedParentCategory?.value123")

  console.log(filterdata , "filterdata------>")

  // const [quickbookid,setQuickbookId]= useState(0)

  const validationSchema = Yup.object().shape({
    // Name: Yup.string().required("Category name is required"),
    Name: Yup.string().required("Category Name is required"),
  });

  console.log(checkedBox, "checkedBox");

  // Get all data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${filtertext}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setData(res.data.ResponseData);
        if(filtertext == ""){
          setfilterdata(res.data.ResponseData);
        }
        setLoading(false);

        const updatedData = res.data.ResponseData?.filter(
          (el) => el.IsShowEcommerceMenu === 1
        );
        const idArray = updatedData.map((el) => el.ID);
        setCheckedBox(idArray);

        if (res.data.ResponseData?.length === idArray?.length) {
          setValueAllChecked(true);
        } else {
          setValueAllChecked(false);
        }
        // console.log(idArray, "idArray");
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData(1, perPage, searchtext, sortingId, sortingDirection);
  }, []);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.categoriesBaseUrl}/categories/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const categoriesData = res.data.ResponseData[0];
        console.log(categoriesData, " categoriesDatacategoriesData");
        // console.log(categoriesData.ParentRefQuickbookId,"categoriesData")
        setParentRefQuickBookId(categoriesData.ParentRefQuickbookId);
        // setselectedParentCategory({quickbookid: categoriesData.QuickbookId})
        const data = {
          ID: categoriesData.ID,
          Name: categoriesData.Name,
          Hidefromgrid: categoriesData.Hidefromgrid === 1 ? true : false,
          ParentID: categoriesData.ParentId,
          Color: categoriesData.Color,
          Imagename: categoriesData.Imagename || "",
          CategoryInfopopup: categoriesData.CategoryInfopopup,
        };
      
        setFormValues(data);
        setImageUrl(categoriesData.Imagename);
        // ParentCategoryOption.map((selectCategory) => {
        //   if (selectCategory.value == categoriesData.ParentId) {
        //     setselectedParentCategory({
        //       ...selectCategory,
        //       quickbookid: categoriesData.QuickbookId,
        //     });
        //   }
        // });

        setselectedParentCategory(categoriesData.ParentId)
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Crete and Update Data
  const handleSubmit2 = async (event) => {
    setLoading(true);
    console.log(selectedImage, "selectedImage");
    if (selectedImage) {
      if (validation("Imagename", selectedImage)) {
        await uploadFile(selectedImage, "Imagename", event);
      }
    } else {
      console.log(event, "event");
      handleSubmit("", event);
    }
  };

  const handleSubmit = async (imageurl, eventObject) => {
    // console.log("Submit2")

    console.log(selectedParentCategory, "selectedParentCategory");
    const data = {
      id: eventObject.ID,
      name: eventObject.Name,
      hidefromgrid: eventObject.Hidefromgrid,
      parentid:
        selectedParentCategory === undefined
          ? 0
          : selectedParentCategory,
      imagename: uploadImageUrlArray.join(","),
      color: eventObject.Color,
      categoryinfopopup: eventObject.CategoryInfopopup,
      loginuserid: loginUserId,
      quickbookid: selectedParentCategory?.quickbookid,
      parentrefquickbookid: parentrefquickbookid,
    };

    console.log(data, "datacategory");
    // setLoading(false);
    // return;

    axios
      .post(`${config.categoriesBaseUrl}/categories/upsert`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData();

          eventObject.Name = "";
          eventObject.ID = 0;
          setLoading(false);
          window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  // Delete Tag
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      id: pID,
      loginuserid: loginUserId,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = {
      ID: 0,
      Name: "",
      Hidefromgrid: false,
      ParentID: 0,
      Color: "",
      Imagename: "",
      CategoryInfopopup: "",
    };
    setFormValues(clearData);
    setImageUrl("");
  };

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = {
      label: u.Name,
      value: u.ID,
      quickbookid: u.QuickbookId,
      parentrefquickbookid: u.ParentRefQuickbookId,
    };
  });
  
  let ParentCategoryOption1 = [];
  const ItemKits1 = filterdata.map((u, i) => {
    ParentCategoryOption1[i] = {
      label: u.Name,
      value: u.ID,
      quickbookid: u.QuickbookId,
      parentrefquickbookid: u.ParentRefQuickbookId,
    };
  });
  console.log(ParentCategoryOption, "ParentCategoryOption123");


  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  // old
  /* AWS FILE UPLOAD */
  // const _handleFileChange = (e) => {
  //   setChangeImagename(true);

  //   if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
  //     uploadFile(e?.currentTarget?.files[0], e.target.name);
  //   }
  // };

  //new
  const _handleFileChange = (e) => {
    console.log(e, "imageUpload");

    const file = e.target.files[0];
    setSelectedImage(file);

    if (file) {
      // Display a preview of the selected image
      setPreviewImage(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewImage(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // old
  // const vaidation = (name, value) => {
  //   switch (name) {
  //     case "Imagename":
  //       if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
  //         return false;
  //       } else {
  //         return true;
  //       }
  //     default: {
  //       return true;
  //     }
  //   }
  // };

  const validation = (name, value) => {
    console.log(value, "value");
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  let uploadImageUrlArray = [];
  console.log(ImageUrl, "ImageUrl");
  const uploadFile = async (file, type, event) => {
    setShowLoaderUploadImage(true);
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_CATEGORIES, (data) => {
      if (data) {
        setImageUrl(data);
        uploadImageUrlArray.push(data);
        setShowLoaderUploadImage(false);
        handleSubmit(data, event);
      }
    });
  };
  /* END AWS FILE UPLOAD */

  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleAllSwitchOnOff(valueAllChecked);
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setValueAllChecked(!valueAllChecked);
  };

  const handleAllSwitchOnOff = (checked) => {
    // const { checked } = e.target;
    console.log(checked, "checkedBy Allcategory");

    if (checked == true) {
      let finalArray = [];
      data.map((el) => finalArray.push(el?.ID));
      setCheckedBox(finalArray);

      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 1,
        };
      });
      setData(updatedData);
      // setfilterdata(updatedData);
      checkFunction(finalArray);
    } else {
      setCheckedBox([]);
      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 0,
        };
      });
      setData(updatedData);
      // setfilterdata(updatedData);
      checkFunction([]);
    }
  };

  const handelShowPopup = (checked) => {
    console.log(checked, "checked");
    setValueAllChecked(checked);
    setShowDateFilterModal(true);
  };

  console.log(data, "data");

  const handleSwitchOnOff = (e, row) => {
    const { checked } = e.target;
    console.log(checked, row, "checkedBy Allcategory");

    if (checked === true) {
      console.log(checked, row?.ID, "checkedBy Allcategory");
      const FilterData = [...checkedBox, row?.ID];
      setCheckedBox(FilterData);

      const updatedData = data.map((el) => {
        if (el.ID === row?.ID) {
          return {
            ...el,
            IsShowEcommerceMenu: 1,
          };
        } else {
          return el;
        }
      });
      setData(updatedData);
      // setfilterdata(updatedData);

      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);

      checkFunction(FilterData);
    } else {
      const FilterData = checkedBox.filter((item) => item !== row.ID);
      setCheckedBox(FilterData);

      const updatedData = data.map((el) => {
        if (el.ID === row?.ID) {
          return {
            ...el,
            IsShowEcommerceMenu: 0,
          };
        } else {
          return el;
        }
      });
      setData(updatedData);
      // setfilterdata(updatedData);
      checkFunction(FilterData);

      updatedData?.length === FilterData?.length
        ? setValueAllChecked(true)
        : setValueAllChecked(false);
    }
  };

  const commonColumns = [
    {
      name: "Categories",
      selector: "Name",
      width: "50%",
      sortable: true,
    },
    {
      name: "Image",
      selector: "ImageUrl",
      sortable: true,
      cell: (row) => (
        <>
          <Link to={row.Imagename} target="_blank">
            <img
              src={row.Imagename}
              alt="Selected Image"
              style={{
                // maxWidth: "30px",
                maxHeight: "50px",
                width: "30px",
                margin: "5px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage;
              }}
            />
          </Link>
        </>
      ),
    },
    {
      name: (
        <>
          <input
            class="form-check-input mr-1"
            onChange={(event) => handelShowPopup(event.target.checked)}
            type="checkbox"
            role="switch"
            checked={valueAllChecked === true}
          />{" "}
          <label> Show On Menu</label>
        </>
      ),
      left: true,
      cell: (row) => (
        <>
          <input
            class="form-check-input"
            onChange={(e) => handleSwitchOnOff(e, row)}
            type="checkbox"
            role="switch"
            checked={row?.IsShowEcommerceMenu}
          />
        </>
      ),
    },
  ];
  const actionColumn = {
    name: "Action",
    width: "20%",
    cell: (row) => (
      <>
        <div class="btn-group-sm" role="group">
          {checkUserPermission(PERMISSION_EDIT) ? (
            <Link
              className="btn btn-primary"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#ManageDataModal"
              data-backdrop="static"
              data-keyboard="false"
              onClick={() => handleUpdate(row.ID)}
              // style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            >
              Edit
            </Link>
          ) : (
            ""
          )}
          {checkUserPermission(PERMISSION_DELETE) ? (
            <Link
              className="btn btn-sm btn-secondary confirm-text ml-2"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.ID)}
              // style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            >
              {/* <i
              class="fa fa-trash "
              data-bs-toggle="tooltip"
              title="Delete"
            ></i> */}
              Delete
            </Link>
          ) : (
            ""
          )}
        </div>
      </>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    //width: "7%",//"100px",
    // minWidth: "100px",
    // width: "100px",
  };
  const columns = [
    ...(checkUserPermission(PERMISSION_EDIT) ||
    checkUserPermission(PERMISSION_DELETE)
      ? [actionColumn]
      : []),
    ...commonColumns,
  ];

  const handlePerRowsChange = async (page, newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPage, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPage, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPage, e.target.value, sortingId, sortingDirection);
  };

  console.log(checkedBox.join(","), "checkedBox");

  const checkFunction = (checkedCategory) => {
    let categoriesList = {
      categoriesList: checkedCategory.join(","),
      LoginUserId: loginUserId,
    };

    axios
      .post(
        `${config.categoriesBaseUrl}/categories/assignecommercemenu`,
        categoriesList,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // toastSuccess(SUCCESS_MESSAGE)
          console.log("SetDone");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError(ERROR_EXISTS);
        } else {
          // toastError(ERROR_MESSAGE);
        }
      });
  };

  // useEffect(() => {
  //   let categoriesList =
  //   {
  //     categoriesList: checkedBox.join(","),
  //     LoginUserId: loginUserId
  //   };

  //     axios
  //     .post(
  //       `${config.categoriesBaseUrl}/categories/assignecommercemenu`,
  //       categoriesList,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         // toastSuccess(SUCCESS_MESSAGE)
  //         console.log("SetDone");
  //       } else if (
  //         res.data.ResponseCode === "ERROR" &&
  //         res.data.ResponseID === -1
  //         ) {
  //           // toastError(ERROR_EXISTS);
  //         } else {
  //           // toastError(ERROR_MESSAGE);
  //         }
  //       })

  //     }, [checkedBox]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title" >Item: Categories</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "11px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Categories</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="col-md-4">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  onClick={() => handleManageDataPopup()}
                >
                  {/* <img src={PlusIcon} alt="img" className="me-1" /> Add Category{" "} */}
                  <i className="fa fa-plus me-2 lg"></i>Add Category
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* Data list */}
          {/* <div className="row">
            <div className="row flex-row-reverse">
              <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-50 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div>
            </div>
          </div> */}
          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  <DataTable
                    // title="Category List"
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[100, 200, 400, 500]}
                    persistTableHead
                    onChangeRowsPerPage={(e) => {
                      handlePerRowsChange(1, e);
                    }}
                    perPage={100}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    dense
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Data list */}
        </div>
      </div>

      {/* Upset Model  */}
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="p-lg">Manage Categories</h6>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit2}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="row mb-2">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Parent Category
                          </label>
                          <div className="col-md-9">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              onChange={(el) =>
                                setselectedParentCategory(el.value)
                              }
                              options={ParentCategoryOption1}
                              placeholder="Select Parent Category"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              value={ParentCategoryOption1.find(
                                (el) =>
                                  el.value == selectedParentCategory
                              )}
                              id="ParentID"
                              name="ParentID"
                              className="custom-search-select"
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Category Name<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <Field
                              type="text"
                              name="Name"
                              className={` form-control form-control-sm ${
                                errors.Name ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Category Name"
                              // value={values.Name}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.Name && errors.Name ? errors.Name : ""}
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Category Color
                          </label>
                          <div className="col-md-9">
                            <Field
                              type="color"
                              name="Color"
                              className={`form-control form-control-sm form-control-color w-1`}
                              value={values.Color}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </div>
                          {/* <div className="invalid-feedback">{touched.Color && errors.Color ? errors.Color : ''}</div> */}
                        </div>
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Category Image
                          </label>
                          <div className="col-md-9">
                            {/* <Field
                              type="file"
                              name="Imagename"
                              className="form-control form-control-sm"
                              // value={URL.createObjectURL(selectedImage)}
                              // onBlur={handleBlur}
                              onChange={(e) => _handleFileChange(e)}
                              // loader={btnLoader.Imagename}
                            /> */}
                            <input
                              type="file"
                              onChange={(e) => _handleFileChange(e)}
                              name="Imagename"
                              className="form-control form-control-sm"
                            />
                          </div>

                          {/* <div className="invalid-feedback">{touched.Imagename && errors.Imagename ? errors.Imagename : ''}</div> */}
                        </div>

                        {(previewImage || ImageUrl) && (
                          <div className="row mb-3">
                            <div className="col-md-3"></div>
                            <div className="col-md-9">
                              <img
                                src={previewImage || ImageUrl}
                                alt="Category Image Preview"
                                className="ImagePreviewSize"
                              />
                            </div>
                          </div>
                        )}

                        {/* no need in the system so hided */}

                        {/* <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            Default Hide From Grid:
                          </label>
                          <div className="col-md-9">
                            <div className="input-group">
                              <Field
                                className="form-check-input"
                                style={{ width: "1.5em", height: "1.5em" }}
                                type="checkbox"
                                onChange={handleChange}
                                name="Hidefromgrid"
                                id="Hidefromgrid"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-form-label col-md-3">
                            Information Popup When Adding To Sale:
                          </label>
                          <div className="col-md-9">
                            <Field
                              as="textarea"
                              name="CategoryInfopopup"
                              className={`form-control`}
                              rows={5}
                              cols={5}
                              // value={values.CategoryInfopopup}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </div>
                        </div> */}
                      </div>

                      <div className="col-lg-12 justify-content-right align-center">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary btn-md me-1"
                        >
                          Submit
                        </button>
                        <Link
                          to="#"
                          className="btn btn-sm btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.categoriesBaseUrl}/categories/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      {/* select all category popup */}
      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Confirmation</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleDateFilterCancel()}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6 className="col-form-label p-lg-medium">
                    Do you want to set at All ?
                  </h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;
